import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FeedbackModel } from "../../models/inModels/feedbackModel";

import 'rxjs/add/operator/toPromise';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggingService } from '../logging/logging.service';
import { LazyLoadEvent } from 'primeng/api';

@Injectable()
export class FeedbackService {
    route = "/api/feedback/";
    constructor(
        private http: HttpClient,
        private auth: AuthenticationService,
        private logging: LoggingService) { }

    sendFeedback(model: FeedbackModel): Promise<any> {
        return this.http.post(`${this.auth.apiUrl}${this.route}create`, JSON.stringify(model), { headers: this.auth.header })
            .toPromise()
            .then(response => response)
            .catch(error => this.logging.handleError(error));
    }

    search(event: LazyLoadEvent): Promise<any>{
        return this.http.post(`${this.auth.apiUrl}${this.route}search`, JSON.stringify(event), { headers: this.auth.header })
            .toPromise()
            .then(response => {
               console.log(response);
                return response;
            })
            .catch(error => this.logging.handleError(error));
	}

	delete(id: number): Promise<any> {
		return this.http.get(`${this.auth.apiUrl}${this.route}delete/${id}`, { headers: this.auth.header })
			.toPromise()
			.then(response => response)
			.catch(error => this.logging.handleError(error));
	}
}



// WEBPACK FOOTER //
// ./src/app/services/user/feedback.service.ts